/** useBillingPlans — Layer 3 query hook for the plan matrix. */
import { useQuery } from "@tanstack/react-query";
import { billingPlansQueryOptions } from "../api/billingQueryOptions";

export function useBillingPlans() {
  return useQuery(billingPlansQueryOptions);
}
